import { BaseService } from "./baseService";
import httpRequest from "./index";

// 组织机构认证
export class InstitutionApplyService extends BaseService<any, any, any, any> {
    // 新增
    public async add(params: any) {
        return await this.service.post(this.path, params);
    }
    // 编辑
    public async edit(id: number, params: any) {
        return await this.service.put(`${this.path}/${id}`, params);
    }
    // 查询用户最新一条认证记录
    public async getLatestCertificationRecord() {
        const { data } = await this.service.get(`${this.path}/customer`);
        return data;
    }

    // 查询用户最新一条认证记录
    public async getLatestCertificationRecordV2() {
        const { data } = await this.service.get(`${this.path}/customer-v2`);
        return data;
    }
}
export const institutionApplyService = new InstitutionApplyService("/institution-apply", httpRequest);
